import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { BiCopyAlt } from '@react-icons/all-files/bi/BiCopyAlt';
import { BiCheck } from '@react-icons/all-files/bi/BiCheck';
import { trackEvent } from '../analytics';

export function ClipboardText(props: {
  children: string;
  textToCopy?: string;
  className?: string;
  wrapText?: boolean;
  buttonClassName?: string;
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setTimeout(() => setCopied(false), 1000);
  }, [copied]);

  return (
    // @ts-ignore
    <CopyToClipboard
      text={props.textToCopy ?? props.children}
      onCopy={() => {
        setCopied(true);
        trackEvent('Click To Copy Field', { field: props.children });
      }}
    >
      <button
        type="button"
        onClick={(e) => e.stopPropagation()}
        className={classNames(
          'flex group py-1 px-2 items-center rounded-md transition-all focus:outline-none box-border -ml-2',
          copied ? 'hover:bg-green-100' : 'hover:bg-gray-100',
          !props.wrapText && 'truncate',
          props.buttonClassName,
        )}
      >
        <p className={props.className}>{props.children}</p>
        <p
          className={classNames(
            'ml-1 text-xs opacity-0 group-hover:opacity-100 transition-all',
            copied ? 'text-green-700' : 'text-gray-400',
          )}
        >
          {copied ? <BiCheck /> : <BiCopyAlt />}
        </p>
      </button>
    </CopyToClipboard>
  );
}
